<template>
  <div class="form-time-wrapper">
    <label class="form-label" for="vrijeme-pocetka">
      <span>{{label}}</span>
    </label>
    <div
      :class="['timepicker', 'timepicker1']"
      dir="ltr"
      @click="addFocus(0, $event)"
    >
      <div>
        <input
          type="text"
          :id="is_first ? 'pocetak' : 'switch-here'"
          class="hh N form-input time-input"
          min="0"
          max="23"
          placeholder="hh"
          maxlength="2"
          ref="dt_st_hh"
        />:
        <input
          type="text"
          :id="is_first ? 'switch-from' : 'end'"
          class="mm N form-input time-input"
          min="0"
          max="59"
          placeholder="mm"
          maxlength="2"
          ref="dt_st_mm"
        />
      </div>
      <v-menu
        ref="vrijemePocetkaChooser"
        v-model="menu1"
        :close-on-content-click="false"
        :nudge-right="20"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <div
            :class="[is_invalid ? 'invalid' : '', 'time-sv']"
            color="time-custom"
            v-bind="attrs"
            v-on="on"
            @click="menu1 = !menu1"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="15"
              height="16"
              viewBox="0 0 15 16"
            >
              <g>
                <g>
                  <path
                    fill="#606076"
                    d="M15 7.765A7.476 7.476 0 1 1 7.524.289 7.484 7.484 0 0 1 15 7.765zM8.058 3.493a.534.534 0 0 0-1.068 0v3.738H3.252a.534.534 0 0 0 0 1.068h4.272a.534.534 0 0 0 .534-.534z"
                  />
                </g>
              </g>
            </svg>
          </div>
        </template>
        <v-time-picker
          v-if="menu1"
          v-model="dt_start_chooser"
          full-width
          format="24hr"
          scrollable
          color="time-custom"
        ></v-time-picker>
      </v-menu>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
export default {
    props:['is_first',"label"],
    data() {
        return {
            menu1:false,
            dt_start_chooser:'',
            is_invalid:false,
        }
    },
    watch:{
        menu1:function(){
            if(this.menu1 && this.$refs.dt_st_hh.value != '' && this.$refs.dt_st_mm.value != ''){
                this.dt_start_chooser = this.$refs.dt_st_hh.value+':'+this.$refs.dt_st_mm.value;
            }
            else{
                if (this.dt_start_chooser != '') {
                let separated = this.dt_start_chooser.split(':');
                this.$refs.dt_st_hh.value = separated[0];
                this.$refs.dt_st_mm.value = separated[1];
                $(".timepicker1")
                .removeClass("invalid")
                .addClass("valid");
                }
            }
        },
    },
    methods:{
        addFocus(polje,e){
            if (!e.target.className.includes('time-input')) {
                if (polje == 0) {
                $('#pocetak').focus();
                }
                else{
                $('#switch-here').focus();
                }
            }
        },
    },
    destroyed() {
      $('#switch-here').off();
      $('#pocetak').off();
    },
}
</script>